module.exports = __webpack_public_path__ + "img/dental-shaking.2a8cd415.svg";